import {
  WidgetConfiguration,
  WidgetConfigurationChannelInfo,
} from "@/types/inboundWebhookPayload";
import { computed, ref } from "vue";

const config = ref<WidgetConfiguration>();

export function useWidgetConfig() {
  const setConfiguration = (state: WidgetConfiguration) => {
    config.value = state;
  };

  const canStartDirectAnyChannel = computed(() => {
    return config.value?.channels?.some(
      (i) => i.startDirectTarget && i.offerStartDirect === true
    );
  });

  const canTransferToAnyChannel = computed(() => {
    return config.value?.channels?.some((i) => i.offerTransfer);
  });

  const getSurveyFieldIdsByChannel = (
    channel: WidgetConfigurationChannelInfo["channel"]
  ) => {
    switch (channel) {
      case "email":
        return (
          config.value?.preChatSurveyFields
            .filter((i) => i.type === "email")
            .map((i) => i.id) ?? []
        );

      case "whatsapp":
      case "sms":
        return (
          config.value?.preChatSurveyFields
            .filter((i) => i.type === "phone-number")
            .map((i) => i.id) ?? []
        );

      default:
        return [];
    }
  };

  return {
    setConfiguration,

    configuration: computed(() => config.value),
    branding: computed(() => config.value?.branding),
    canStartDirectAnyChannel,
    canTransferToAnyChannel,

    getSurveyFieldIdsByChannel,
  };
}
